import { ConfirmPassword } from '@ui/form-items';
import { coreActions } from '@sonar-software/sonar-core';
import { createAsyncSelectors } from '@lib/selectors';
import { CurrentPasswordModal } from '@ui/CurrentPasswordModal';
import { AUTOCOMPLETE, COPY_SPECIFIC, NOTIFICATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import { Button, Form, Row } from 'antd';
import React, { useCallback, useEffect } from 'react';
import { useAction, useAppNotifications, useAsyncState, useBoolean } from '@hooks';
const selectors = createAsyncSelectors((state) => state.core.users.byId.password.patch);
export const ChangePassword = () => {
    const [displayModal, setDisplayModal] = useBoolean(false);
    const [form] = Form.useForm();
    const { successNotification } = useAppNotifications();
    const { isErrored, isFailed, isRequested, isReceived } = useAsyncState(selectors);
    const requestPasswordChange = useAction(coreActions.requestPatchCoreUsersByIdPassword);
    const resetRequest = useAction(coreActions.resetPatchCoreUsersByIdPassword);
    const handleOk = useCallback((currentPassword) => {
        const desiredPassword = form.getFieldValue('confirmPassword');
        requestPasswordChange({
            currentPassword,
            desiredPassword
        });
    }, [form, requestPasswordChange]);
    useEffect(() => {
        if (isReceived) {
            resetRequest();
            setDisplayModal.off();
            form.resetFields();
            successNotification(NOTIFICATIONS_COPY.SUCCESS_PATCH_USER_CHANGE_PASS);
        }
    }, [form, isReceived, resetRequest, setDisplayModal, successNotification]);
    return (React.createElement("div", { id: 'change-password' },
        React.createElement(Form, { form: form, name: 'changePassword', onFinish: setDisplayModal.on },
            React.createElement(ConfirmPassword, { autoComplete: AUTOCOMPLETE.NEW_PASSWORD, disabled: isRequested, id: 'change-password' }),
            React.createElement(CurrentPasswordModal, { error: isErrored, errorMessage: NOTIFICATIONS_COPY.ERROR_PATCH_USER_CHANGE_PASS, failed: isFailed, failedMessage: NOTIFICATIONS_COPY.FAILED_PATCH_USER_CHANGE_PASS, onCancel: setDisplayModal.off, onOk: handleOk, open: displayModal }),
            React.createElement(Row, { justify: 'space-between' },
                React.createElement(Button, { disabled: isRequested, htmlType: 'submit', id: 'change-password-submit-button', type: 'primary' }, COPY_SPECIFIC.CHANGE_PASSWORD)))));
};
